/**
 * RUT chileno con puntos y guion SOLO para mostrar — espejo del
 * formatRutDisplay del backend (captationEngine.utils.js). El
 * almacenamiento siempre es canónico: sin puntos ni guion, minúsculas
 * (regla del producto, dni.utils.js).
 */
export const formatRut = (raw) => {
  if (!raw) return '—';
  const clean = String(raw).toLowerCase().replace(/[^0-9k]/g, '');
  if (!/^\d{7,8}[0-9k]$/.test(clean)) return String(raw);
  const body = clean.slice(0, -1);
  const dv = clean.slice(-1).toUpperCase();
  return `${body.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}-${dv}`;
};

export default formatRut;
